import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TirPmSystemMessage } from "tir-pm-system-message";
import { ExclamationTriangleIcon } from "tir-style-system/icons/outline";

export default /*#__PURE__*/_defineComponent({
  __name: 'DontLookupPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmSystemMessage), { style: {"width":"100%"} }, {
    topDescImage: _withCtx(() => [
      _createVNode(_unref(ExclamationTriangleIcon), { style: {"width":"2.625rem","height":"2.625rem"} })
    ]),
    mainTitleSlot: _withCtx(() => [
      _createTextVNode(" Страница находится в разработке ")
    ]),
    mainSubtitleSlot: _withCtx(() => [
      _createTextVNode(" Перейдите на другой раздел ")
    ]),
    _: 1
  }))
}
}

})